import React, { HTMLAttributes, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import {
  View,
} from '@uncinc/react-drupal-core';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import {
  Breadcrumbs, Button, Main, Popup, PopupCreateNickname,
} from '../../../components';
import { ImmutableGenericTaxonomyEntity } from '..';

import './style.scss';
import usePopup from '../../../hooks/usePopup';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericTaxonomyEntity;
}

const ForumCategory: React.FC<Props> = ({
  entity,
  className,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const { t } = useTranslation();
  const tid = String(entity.getIn(['tid', 0, 'value']));

  const uid = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['login', 'uid'], null));
  const nickname = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['user', uid, 'field_nickname', 0, 'value'], ''));

  const popup = usePopup('createNicknamePopup', {
    closeOnEscape: true,
  });

  const history = useHistory();

  const categoryPostsCount = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['view', 'forum_category_posts', 'default', 'pager', 'total_items'], 0));

  const buttonProps = nickname ? {
    href: t('routes:zelfhulp.forum.create_post_href', { category: tid }),
  } : {
    onClick: () => popup.open(),
  };

  return (
    <Main className={classNames('ForumCategory', 'col-12 col-lg-10 py-8 py-lg-12', className)}>
      {popup.isOpen && (
        <Popup
          {...popup.popupProps}
          title={t('pages.forum_nickname.title')}
          showCloseButton={false}
        >
          <PopupCreateNickname
            onClose={popup.close}
            onNicknameCreated={() => {
              popup.close();
              history.push(t('routes:zelfhulp.forum.create_post_href', { category: tid }));
            }}
          />
        </Popup>
      )}
      <div className="row">
        <div className="Page__introduction col-12">
          <Breadcrumbs />
          <h1 className="u-word-break">{entity.getIn(['name', 0, 'value'])}</h1>
          <p>{t('pages.forum_category_post_header.response_count_text', { count: categoryPostsCount })}</p>
          <Button {...buttonProps}>{t('pages.forum_post_create.button_create')}</Button>
        </div>
        <div className="Page__content col-12">
          <View
            id="forum_category_posts"
            display="default"
            args={[entity.getIn(['tid', 0, 'value'])]}
            page={currentPage}
            setCurrentPage={setCurrentPage}
            resetStateOnUnmount
            displayInitialLoadingState
          />
        </div>
      </div>
    </Main>
  );
};

export default ForumCategory;
